var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#ECAB2F","stroke":"#ECAB2F","strokeWidth":"37.6152","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\r\n\t259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 \r\n\t29.274,197.007 188.165,173.919 "}));
}

Star.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"16px","height":"16px","viewBox":"0 0 512 512","enableBackground":"new 0 0 512 512","xmlSpace":"preserve"};

module.exports = Star;

Star.default = Star;
